'use client';

import { FC, useContext } from 'react';
import { Flex, Timestamp, Text, Signature } from '@/_components';
import { SignatureCompletedProps } from './SignatureCompleted.types';
import { PREDEFINED_MARKED_NOT_NEEDED } from '@/_constants/questions';
import { usePrint } from '@/_hooks/usePrint';
import { ClientQuestionnaireContext } from '@/_contexts/client/ClientQuestionnaireProvider';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';

export const SignatureCompleted: FC<SignatureCompletedProps> = ({
  signature,
}) => {
  const { selectedSection } = useContext(ClientQuestionnaireContext);
  const { firm } = useContext(FirmSettingsContext);

  const { print } = usePrint(
    firm?.name && selectedSection?.name
      ? `${firm?.name} - ${selectedSection?.name}`
      : '',
  );

  if (!signature?.signature) return null;

  const printSignedDocument = () => {
    print();
  };

  // marked completed
  if (signature?.signature === PREDEFINED_MARKED_NOT_NEEDED) {
    return (
      <Flex isColumn={true} gap={6} isCentered={true}>
        <Text type="small" color="secondary" textAlign="center">
          Signature for {signature?.user_name} was marked not needed.
        </Text>
      </Flex>
    );
  }

  return (
    <Flex isColumn={true} gap={6} isCentered={true}>
      {signature?.signature && <Signature name={signature?.signature} />}
      <Text type="small" color="secondary" textAlign="center">
        Signed <Timestamp timestamp={signature?.client_time} /> &ndash;{' '}
        <a onClick={printSignedDocument}>Download Signed Document</a>
      </Text>
    </Flex>
  );
};
